const routes = [
  {
    path: '/account', // 账户主页面
    name: 'account',
    component: () => import('@src/modules/account/main'),
    redirect: '/account/index',
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'index', // 账户信息管理
        name: 'index',
        component: () => import('@src/modules/account/view/Account'),
        meta: {
          requireAuth: true,
          routerAlive: true
        }
      },
      {
        path: 'Permission', // 账户信息管理
        name: 'Permission',
        component: () => import('@src/modules/account/view/Permission'),
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/authGroup', // 设备权限组
    name: 'authGroup',
    component: () => import('@src/modules/account/main'),
    meta: {
      requireAuth: true,
      routerAlive: true
    },
    children: [
      {
        path: 'index', // 账户信息管理
        name: 'authGroupIndex',
        component: () => import('@src/modules/account/view/authGroup'),
        meta: {
          requireAuth: true,
          routerAlive: true
        }
      },
      {
        path: 'operate', // 账户信息管理
        name: 'operate',
        component: () => import('@src/modules/account/view/operate'),
        meta: {
          requireAuth: true,
          module:"authGroup"
        }
      }
    ]
  }
]

export default routes
